import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconWebsite from './nav-icon-website.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconWebsite {...validProps} />;
}
SvgComponent.iconName = 'navIconWebsite';

/**
 * @deprecated This is a legacy icon
 */
export const NavIconWebsiteIcon = svgIconWrapper(SvgComponent);
